<ng-container *ngTemplateOutlet="header"></ng-container>
<ng-container *ngTemplateOutlet="main"></ng-container>
<ng-container *ngTemplateOutlet="footer"></ng-container>

<ng-template #header>
  <!-- <div class="header"></div> -->
</ng-template>

<ng-template #main>
  <div class="main">
    <media-viewer *ngIf="media() as media" 
                  [media]="media" 
                  (onAction)="onMediaAction($event)">
    </media-viewer>
  </div>
</ng-template>

<ng-template #footer>
  <!-- <div class="footer"></div> -->
</ng-template>
